import React from 'react';
import { Link } from 'react-router-dom';

import * as pages from 'common_constants/Pages';
import NavigationService from 'support/navigation/NavigationService';
import SearchIcon from '@material-ui/icons/Search';


const TemplateHeader = ({
    classes,
    totalCount,
    searchTerm,
    onSearchChange,
  }) => {
    const ROUTES = NavigationService.getRoutes();
  
    return (
      <div className={classes.pageHeader}>
        <div>
          <h1 className={classes.pageTitle}>
          List  Scorecard Templates
          </h1>
  
          <p className={classes.pageSubTitle}>
            {totalCount} Scorecards in your workspace
          </p>
        </div>
  
        <div className={classes.headerActions}>
          <div className={classes.searchBox}>
            
            <SearchIcon className={classes.searchIcon} />
            
            <input
              type="text"
              value={searchTerm}
              placeholder="Search template..."
              className={classes.searchInput}
              onChange={event =>
                onSearchChange(event.target.value)
              }
            />
          </div>
  
          <Link
            to={{
              pathname:
                ROUTES[
                  pages.CREATESCORECARDTEMPLATE
                ].path,
            }}
            className={classes.newQuestionnaireBtn}
          >
            + Create New Template
          </Link>
        </div>
      </div>
    );
  };
  

  export default TemplateHeader